(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vid-row-pawsy"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const wrapper = document.querySelector('.vid-row-pawsy-wrapper');
  const videos = Array.from(wrapper.querySelectorAll('video'));

  // Funcție play cu muted pentru autoplay sigur
  function playVideo(video) {
    video.muted = true;
    video.play().catch(err => console.log("Autoplay blocked:", err));
  }

  // Funcție pentru următorul video
  function playNext(currentIndex) {
    const nextIndex = (currentIndex + 1) % videos.length;
    const nextVideo = videos[nextIndex];

    // Scroll lin către următorul video
    nextVideo.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

    // Play video
    playVideo(nextVideo);
  }

  // Eveniment când se termină un video
  videos.forEach((video, i) => {
    video.addEventListener('ended', function() {
      playNext(i);
    });
  });

  // Pornim autoplay pentru toate video-urile de la start
  videos.forEach(video => playVideo(video));
});

  } catch(e) { console.error(e); }
})();
})();
